import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export type SubmitValidationDialogProps = {
    open: boolean;
    isSubmitting: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

// Submitting hands the validation over and locks the panel, which is not something to discover afterwards.
export function SubmitValidationDialog({
    open,
    isSubmitting,
    onConfirm,
    onCancel,
}: SubmitValidationDialogProps): ReactElement | null {
    const { t } = useTranslation();

    if (!open) {
        return null;
    }

    return (
        <Dialog
            open
            onClose={onCancel}
            aria-labelledby="submit-validation-dialog-title"
            aria-describedby="submit-validation-dialog-description">
            <DialogTitle id="submit-validation-dialog-title">
                {t('SETTINGS.VERIFICATION.SUBMIT_DIALOG.TITLE')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="submit-validation-dialog-description">
                    {t('SETTINGS.VERIFICATION.SUBMIT_DIALOG.BODY')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    {t('SETTINGS.VERIFICATION.SUBMIT_DIALOG.CANCEL')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onConfirm}
                    disabled={isSubmitting}
                    startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : undefined}>
                    {t('SETTINGS.VERIFICATION.SUBMIT_DIALOG.CONFIRM')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
